import { ForwardedRef, forwardRef } from 'react';
import { Textarea } from '@components/textarea';
import classNames from 'classnames';

import { Props } from './textarea-counter.types';

export const TextareaCounter = forwardRef(
  (
    { hasError, length, maxLength, charactersText, readOnly, children, onChange, ...props }: Props,
    ref: ForwardedRef<HTMLTextAreaElement>
  ) => {
    const counterClasses = classNames({
      'text-tertiary': !hasError,
      'text-critical': hasError,
    });

    return (
      <div>
        <Textarea readOnly={readOnly} {...props} hasError={hasError} ref={ref} onChange={onChange} />
        <div
          className={`flex flex-row w-full mt-2 justify-between items-center text-body-m ${counterClasses}`}
          data-testid='textarea-counter'>
          {children}
          <p className='ml-auto'>
            {length}/{maxLength} {charactersText}
          </p>
        </div>
      </div>
    );
  }
);
